import propertyObjectClassMapping from 'constants/propertyObjectClassMapping';

export default function (objectConfig) {
  const object = new propertyObjectClassMapping[objectConfig.propertyType](objectConfig);

  object.originalProperties = objectConfig.originalProperties;

  return object;
}
